import { render, staticRenderFns } from "./AutoField.vue?vue&type=template&id=635637ac&scoped=true&lang=pug"
import script from "./AutoField.vue?vue&type=script&lang=js"
export * from "./AutoField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635637ac",
  null
  
)

export default component.exports